import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer-section">
      <div className="footer-wrapper">
        <div className="footer-main-content">
          <div className="footer-brand-column">
            <div className="footer-brand">
              <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 10.7047L4 8V20H0V10.7047Z" fill="url(#paint0_linear_footer)"/>
                <path d="M7 6.58967L11 4V20H7V6.58967Z" fill="url(#paint1_linear_footer)"/>
                <path d="M14 2.51414L18 0V20H14V2.51414Z" fill="url(#paint2_linear_footer)"/>
                <defs>
                  <linearGradient id="paint0_linear_footer" x1="2" y1="8" x2="2" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#77BBFF"/>
                    <stop offset="1" stopColor="#0265C7"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_footer" x1="9" y1="4" x2="9" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#77BBFF"/>
                    <stop offset="1" stopColor="#0265C7"/>
                  </linearGradient>
                  <linearGradient id="paint2_linear_footer" x1="16" y1="0" x2="16" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#77BBFF"/>
                    <stop offset="1" stopColor="#0265C7"/>
                  </linearGradient>
                </defs>
              </svg>
              <span className="footer-brand-text">Mortgage</span>
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.5 1L6.5 12" stroke="#0578EC" strokeWidth="2" strokeLinecap="round"/>
                <path d="M1 6.5L12 6.5" stroke="#0578EC" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </div>
            <p className="footer-address">
              24445 Hawthorne Blvd, 201<br />
              Torrance, CA 90505
            </p>
            <div className="footer-social-links">
              <a href="#" className="social-icon linkedin">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="4" fill="white"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.6279 21.3754H13.1646V12.9346H10.6279V21.3754Z" fill="#0D1226"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M22.4647 16.6764V21.3754H19.9813V16.9375C19.9813 15.8062 19.5808 15.1101 18.6996 15.1101C18.1293 15.104 17.6166 15.4869 17.4179 16.0673C17.3466 16.29 17.3194 16.5276 17.3378 16.7634V21.3754H14.8545V13.1956H17.3378V14.3269C17.804 13.4619 18.6588 12.932 19.5808 12.9346C21.1829 12.9346 22.4647 14.1529 22.4647 16.6764Z" fill="#0D1226"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M11.9321 9.56328C11.2807 9.49163 10.6997 10.0082 10.6337 10.7153C10.6301 10.7515 10.6287 10.7869 10.6279 10.8231C10.6287 11.5216 11.1503 12.0861 11.7923 12.0846C11.8147 12.0846 11.8372 12.0846 11.8596 12.083C12.511 12.1538 13.0921 11.6389 13.158 10.931C13.1609 10.8948 13.1631 10.8594 13.1638 10.8231C13.187 10.1491 12.703 9.58375 12.0835 9.55777C12.0328 9.55619 11.9821 9.55777 11.9321 9.56328Z" fill="#0D1226"/>
                </svg>
              </a>
              <a href="#" className="social-icon instagram">
                <div className="social-icon-box">
                  <img src="https://api.builder.io/api/v1/image/assets/TEMP/644a9ad96a3c7eaa5f3317e61b81de1855ac6238?width=24" alt="Instagram" />
                </div>
              </a>
              <a href="#" className="social-icon facebook">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="4" fill="white"/>
                  <path d="M13.3525 16.2486H14.5802V21.6639C14.5802 21.7708 14.6611 21.8574 14.7609 21.8574H16.8425C16.9423 21.8574 17.0231 21.7708 17.0231 21.6639V16.2741H18.4345C18.5262 16.2741 18.6034 16.2004 18.6139 16.1027L18.8283 14.1091C18.8342 14.0542 18.8179 13.9993 18.7837 13.9581C18.7494 13.9169 18.7003 13.8934 18.6489 13.8934H17.0232V12.6437C17.0232 12.2669 17.2125 12.0759 17.5859 12.0759C17.6392 12.0759 18.6489 12.0759 18.6489 12.0759C18.7486 12.0759 18.8295 11.9892 18.8295 11.8824V10.0524C18.8295 9.94549 18.7486 9.85885 18.6489 9.85885H17.184C17.1737 9.85831 17.1507 9.85742 17.1169 9.85742C16.8627 9.85742 15.9793 9.91088 15.2814 10.5988C14.5082 11.361 14.6157 12.2737 14.6414 12.432V13.8933H13.3525C13.2527 13.8933 13.1719 13.98 13.1719 14.0869V16.055C13.1719 16.162 13.2527 16.2486 13.3525 16.2486Z" fill="#0D1226"/>
                </svg>
              </a>
              <a href="#" className="social-icon twitter">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="32" height="32" rx="4" fill="white"/>
                  <path d="M17.1096 15.1092L21.4487 10.1699H20.4208L16.6516 14.4578L13.6434 10.1699H10.1729L14.7229 16.6545L10.1729 21.8335H11.2007L15.1786 17.3044L18.3562 21.8335H21.8267M11.5717 10.929H13.1508L20.4201 21.1117H18.8406" fill="#0D1226"/>
                </svg>
              </a>
            </div>
            <p className="footer-licensing">
              Valentino Adams NMLS ID: # 1630597<br />
              California Department of Real Estate<br />
              License # 02026623
            </p>
          </div>
          
          <div className="footer-right-content">
            <div className="footer-cta-section">
              <div className="footer-cta-text">
                <h3 className="footer-cta-title">We will find great rate</h3>
                <p className="footer-cta-description">
                  We compare mortgage options to find the best rate tailored for your. Save more with our expert guidance.
                </p>
              </div>
              <div className="footer-cta-buttons">
                <button className="footer-contact-btn">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.28521 6.63989C6.80721 7.72711 7.5188 8.74609 8.41998 9.64727C9.32116 10.5485 10.3401 11.26 11.4274 11.782C11.5209 11.8269 11.5676 11.8494 11.6268 11.8666C11.8371 11.9279 12.0953 11.8839 12.2733 11.7564C12.3234 11.7205 12.3663 11.6777 12.452 11.5919C12.7143 11.3297 12.8454 11.1986 12.9772 11.1129C13.4744 10.7897 14.1153 10.7897 14.6125 11.1129C14.7443 11.1986 14.8754 11.3297 15.1376 11.5919L15.2838 11.7381C15.6823 12.1367 15.8816 12.3359 15.9899 12.55C16.2052 12.9756 16.2052 13.4783 15.9899 13.904C15.8816 14.1181 15.6823 14.3173 15.2838 14.7159L15.1655 14.8342C14.7683 15.2314 14.5697 15.43 14.2997 15.5817C14 15.75 13.5347 15.871 13.191 15.87C12.8813 15.8691 12.6696 15.809 12.2463 15.6888C9.97125 15.0431 7.82448 13.8247 6.0335 12.0338C4.24251 10.2428 3.02415 8.096 2.37843 5.82095C2.25827 5.39762 2.19819 5.18595 2.19727 4.87624C2.19625 4.53258 2.31727 4.06721 2.48559 3.76758C2.63727 3.49755 2.83588 3.29894 3.2331 2.90173L3.35132 2.7835C3.74991 2.38492 3.9492 2.18563 4.16323 2.07737C4.5889 1.86207 5.0916 1.86207 5.51727 2.07737C5.73131 2.18563 5.9306 2.38492 6.32918 2.7835L6.47533 2.92965C6.73754 3.19186 6.86864 3.32296 6.95436 3.45479C7.2776 3.95196 7.2776 4.5929 6.95435 5.09007C6.86864 5.2219 6.73754 5.353 6.47533 5.61521C6.3896 5.70094 6.34673 5.74381 6.31085 5.79392C6.18334 5.97199 6.13932 6.23018 6.20061 6.44045C6.21786 6.49962 6.24031 6.54637 6.28521 6.63989Z" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Contact us
                </button>
                <button className="footer-rate-btn">
                  Get your rate
                  <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.75 6.75H16.75M16.75 6.75L10.75 0.75M16.75 6.75L10.75 12.75" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            
            <div className="footer-links-grid">
              <div className="footer-links-column">
                <h4 className="footer-column-title">Mortgage</h4>
                <div className="footer-links-list">
                  <Link to="/buy-home">Purchase</Link>
                  <Link to="/refinance-home">Refinance</Link>
                  <Link to="/reverse-mortgage">Reverse Mortgage</Link>
                </div>
              </div>
              <div className="footer-links-column">
                <h4 className="footer-column-title">Mortgage Rates</h4>
                <div className="footer-links-list">
                  <Link to="/buy-home">Purchase Rate</Link>
                  <Link to="/refinance-home">Refinance Rate</Link>
                  <Link to="/reverse-mortgage">Reverse Mortgage Rate</Link>
                </div>
              </div>
              <div className="footer-links-column">
                <h4 className="footer-column-title">Support</h4>
                <div className="footer-links-list">
                  <a href="#">Contact us</a>
                  <a href="#">FAQ</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <div className="footer-bottom-content">
            <div className="footer-legal-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Cookie Settings</a>
            </div>
            <p className="footer-copyright">© 2024 Mortgage+. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
 